import { CustomerSalaryRange } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const salaryRangeMessages = defineMessages({
  above20M: {
    defaultMessage: 'Over Rp 20 million',
    description: 'salary range title',
  },
  below5M: {
    defaultMessage: 'Under Rp 5 million',
    description: 'salary range title',
  },
  from10MTo20M: {
    defaultMessage: 'Rp 10–20 million',
    description: 'salary range title',
  },
  from5MTo10M: {
    defaultMessage: 'Rp 5–10 million',
    description: 'salary range title',
  },
})

export function translateSalaryRange(intl: IntlShape, salaryRange: CustomerSalaryRange): string {
  switch (salaryRange) {
    case CustomerSalaryRange.ABOVE_20M:
      return intl.formatMessage(salaryRangeMessages.above20M)
    case CustomerSalaryRange.BELOW_5M:
      return intl.formatMessage(salaryRangeMessages.below5M)
    case CustomerSalaryRange.FROM_10M_TO_20M:
      return intl.formatMessage(salaryRangeMessages.from10MTo20M)
    case CustomerSalaryRange.FROM_5M_TO_10M:
      return intl.formatMessage(salaryRangeMessages.from5MTo10M)
  }
}
